import { threads } from '@/mocks/homeData';

const avatarColors = ['bg-primary-500', 'bg-accent-600', 'bg-secondary-600', 'bg-primary-800'];

export default function Community() {
  return (
    <section id="community" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-accent-700"># 社区 · 热议区</p>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              老用户都在<span className="text-primary-600">线实时补充</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">评论区比正片精彩——补料、对账、反带节奏，都在这里发生。</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="flex -space-x-2">
              {['标', '半', '夜', '瓜'].map((n, i) => (
                <span
                  key={n}
                  className={`flex h-7 w-7 items-center justify-center rounded-full text-[11px] font-bold text-background-50 ring-2 ring-background-100 ${avatarColors[i]}`}
                >
                  {n}
                </span>
              ))}
            </span>
            <span className="whitespace-nowrap text-xs text-foreground-500">1.2万人正在围观</span>
          </div>
        </div>

        {/* 讨论串 */}
        <div className="mt-8 grid gap-4 lg:grid-cols-2">
          {threads.map((t, i) => (
            <article
              key={t.name}
              className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition hover:border-primary-200"
            >
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-heading text-sm font-bold text-background-50 ${avatarColors[i % avatarColors.length]}`}
                >
                  {t.name.slice(0, 1)}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">
                    {t.role} · {t.time}
                  </p>
                </div>
                <span className="ml-auto flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                  {t.tag}
                </span>
              </div>

              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{t.text}</p>

              <div className="mt-4 flex items-center gap-5 border-t border-background-100 pt-3 text-sm text-foreground-400">
                <button type="button" className="flex items-center gap-1.5 transition hover:text-primary-600">
                  <i className="ri-chat-3-line text-base" /> {t.replies} 回复
                </button>
                <button type="button" className="flex items-center gap-1.5 transition hover:text-accent-600">
                  <i className="ri-heart-3-line text-base" /> {t.likes} 赞同
                </button>
                <button type="button" className="ml-auto flex items-center gap-1.5 transition hover:text-primary-600">
                  <i className="ri-share-forward-line text-base" /> 转发
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 flex justify-center">
          <a
            href="#community"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-refresh-line" />
            加载更多热议
          </a>
        </div>
      </div>
    </section>
  );
}